import React, {useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Paper } from '@mui/material';

import FleetForm from './FleetForm';
import { createVehicle } from './FleetSlice';


function CreateVehicle () {
    const { isLoading } = useSelector((state) => state.fleet);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [registration, setRegistartion] = useState('');
    const [model, setModel] = useState(null);
    const [locations, setLocations] = useState([]);
    const [isPlaceholder, setIsPlaceholder] = useState(false);
    const vehicle = {
        registration: registration,
        model: model,
        locations: locations,
        is_placeholder: isPlaceholder
    };

    const handleNewLocation = (event) => {
        const {target: {value},} = event;
        setLocations(typeof value === 'string' ? value.split(',') : value)
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        dispatch(createVehicle(vehicle));
        navigate('/manage/fleet');
    }

    return (
        <Container>
            <Typography variant='h3' align='center' gutterBottom>
                Add car
            </Typography>
            <Paper sx={{padding: 2}}>
                <FleetForm
                    action='create'
                    isLoading={isLoading}
                    vehicle={vehicle}
                    onRegistrationChange={setRegistartion}
                    onModelChange={setModel}
                    onLocationChange={handleNewLocation}
                    onPlaceholderChange={setIsPlaceholder}
                    handleSubmit={handleSubmit}
                />
            </Paper>
        </Container>
    )
}

export default CreateVehicle